var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ic-typeahead", {
    attrs: {
      id: _vm.id,
      text: _vm.searchText,
      options: _vm.searchOptions,
      getValue: _vm.getValueDefault,
      getText: _vm.getTextDefault,
      selectFirst: _vm.selectFirst,
      onInputChange: _vm.onInputChangeDefault,
      minLength: _vm.minLength,
      loading: _vm.isLoading,
    },
    on: {
      "update:text": function ($event) {
        _vm.searchText = $event
      },
      "update:item": function ($event) {
        _vm.searchItem = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function (props) {
          return _c("a", { attrs: { href: "#", role: "option" } }, [
            _vm._v(_vm._s(props.item.n)),
          ])
        },
      },
    ]),
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }